import { LegendOption } from 'echarts/types/dist/shared';

import { DatasetBase } from '@core/reports-types';

import { categoryNameFormatter } from '../formatter';

export const addLegendNameFormatting =
  (dataset: DatasetBase) =>
  <
    T extends {
      legend: LegendOption;
    },
  >(
    opts: T,
  ): T => ({
    ...opts,
    legend: {
      formatter: categoryNameFormatter(dataset),
    },
  });
